<template>
  <router-view />
</template>

<style lang="scss">
  @use "styles/font.scss" as *;
  @use "styles/main.scss" as *;
</style>
